import { useEffect, useState } from 'react';

import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import {
  Loader, Button, Checkbox, SelectMultiple,
} from 'components';
import { useStateVar } from 'helpers/useStateVar';
import {
  apiCall,
  ApiResps,
  apiCallFormData,
  apiCallDownload,
} from 'providers';
import { CustomizedButton } from '~/components/CutomizedButton';
import {
  FileInput,
  BottonTypeSolution,
  PreFillGuideArea,
  ContainerExportationAndDowload,
  StyleSelect,
  Label,
  Table,
  BorderSubItem,
} from './styles';
import { useTranslation } from 'react-i18next';
import { colors } from '~/styles/colors';
import { Option, stateObject } from '../../../helpers/batchInputHelpers';
import { PreFillGuide } from './PreFillGuide';
import SelectSearch, { fuzzySearch } from 'react-select-search';
import { AxiosError } from 'axios';
import { LoaderWithText } from '~/components/LoaderWithText';
import { formatNumber } from '~/helpers/formatNumber';
import {
  HorizontalLineSelectParameters, InfoSelected, InputStyledSelected, SelectOptionStyled,
} from '~/pages/Analysis/Integrations/IntegrHistory/ChillerCarrierHistory/components/styles';
import { SelectedContent } from '~/components/PinEditModal/styles';

export const BatchInputUnified = ({ clientId }): JSX.Element => {
  const { t } = useTranslation();
  const [state, render, setState] = useStateVar(stateObject());
  const [typesOfSolutions, setTypesOfSolutions] = useState([
    {
      name: t('unidade'), value: 'unit', checked: false, index: 0,
    },
    {
      name: t('maquina'), value: 'machine', checked: false, index: 1,
    },
    {
      name: t('ambiente'), value: 'environment', checked: false, index: 2,
    },
    {
      name: t('energia'), value: 'energy', checked: false, index: 3,
    },
    {
      name: t('agua'), value: 'water', checked: false, index: 4,
    },
    {
      name: t('utilitarios'), value: 'utility', checked: false, index: 5,
    },
    {
      name: t('iluminacao'), value: 'illumination', checked: false, index: 6, type: 'U',
    },
    {
      name: 'Nobreak', value: 'nobreak', checked: false, index: 7, type: 'U',
    },
    {
      name: t('elevador'), value: 'elevador', checked: false, index: 8, type: 'U',
    },
    {
      name: t('escadaRolante'), value: 'escada rolante', checked: false, index: 9, type: 'U',
    },
    {
      name: t('gerador'), value: 'gerador', checked: false, index: 10, type: 'U',
    },
    {
      name: t('caixaDagua'), value: "caixa d'água", checked: false, index: 11, type: 'U',
    },
    {
      name: t('alarmeIntrusao'), value: 'alarme de intrusão', checked: false, index: 12, type: 'U',
    },
    {
      name: t('alarmeIncendio'), value: 'alarme de incêndio', checked: false, index: 13, type: 'U',
    },
  ]);

  useEffect(() => {
    fetchServerData();
  }, []);

  function generateFancoilOptions(comboOpts: ApiResps['/dev/dev-info-combo-options']) {
    if (!comboOpts.fancoils) return;

    const thermManufOpts: Option[] = [];
    const fancoilManufOpts: Option[] = [];
    const valveManufOpts: Option[] = [];

    for (const fancoil of comboOpts.fancoils) {
      if (fancoil.label === 'Outro (digitar)') continue;
      if (fancoil.type === 'THERM_MANUF') thermManufOpts.push({ value: fancoil.value, label: fancoil.label });
      if (fancoil.type === 'VALVE_MANUF') valveManufOpts.push({ value: fancoil.value, label: fancoil.label });
      if (fancoil.type === 'FANCOIL_MANUF') fancoilManufOpts.push({ value: fancoil.value, label: fancoil.label });
    }

    state.comboOpts = {
      ...comboOpts,
      fancoilsManuf: fancoilManufOpts,
      fancoilsThermManuf: thermManufOpts,
      fancoilsValveManuf: valveManufOpts,
    };
  }

  async function fetchServerData() {
    try {
      const [
        { unified: fetchedColumns },
        comboOpts,
        energyOpts,
      ] = await Promise.all([
        apiCall('/batch-input-columns', { unified: true }),
        apiCall('/dev/dev-info-combo-options', {
          CLIENT_ID: clientId,
          units: true,
          groups: true,
          fluids: true,
          applics: true,
          types: true,
          envs: true,
          vavs: true,
          brands: true,
          roles: true,
          psens: true,
          rtypes: true,
          dutPlacement: true,
          evaporatorModels: true,
          fancoils: true,
        }),
        await apiCall('/energy/get-energy-combo-opts', {}),
      ]);
      const dielManufInfo = energyOpts.manufacturersList.find((x) => x.NAME === 'Diel Energia');
      const filteredModels = energyOpts.modelsList.filter((x) => x.MANUFACTURER_ID === dielManufInfo!.MANUFACTURER_ID);
      if (comboOpts.applics) {
        comboOpts.applics.push({ value: 'Medidor de Energia', label: 'Medidor de Energia' }, { value: 'Carrier ECOSPLIT', label: 'Splitão Inverter' });
      }
      state.comboOpts = comboOpts;
      generateFancoilOptions(comboOpts);
      state.energyOpts = filteredModels;
      state.columns = fetchedColumns;
    } catch (err) { console.log(err); toast.error('Houve erro'); }
    state.isLoading = false; render();
  }

  async function exportUnitUnified() {
    if (state.isLoading) return;
    state.isExporting = true;
    render();
    try {
      if (!state.selectedTypeOfSolution) {
        toast.error(t('selecioneOsTiposDeSolução'));
        return;
      }
      const exportResponse = await apiCallDownload('/export-client-unified-batch-input', {
        clientId,
        units: state.selectedUnit.map((item) => Number(item)),
        typeOfSolutions: state.selectedTypeOfSolution.map((item) => item.value),
      });
      state.isExporting = false;
      render();
      const link: any = document.getElementById('downloadLink');
      if (link?.href !== '#') window.URL.revokeObjectURL(link.href);
      link.href = window.URL.createObjectURL(exportResponse.data);
      link.download = exportResponse.headers.filename || 'Unificada.xlsx';
      link.click();
      toast.success(t('sucessoExportacao'));
    } catch (err) {
      console.log(err);
      state.isExporting = false;
      render();
      toast.error(t('naoFoiPossivelExportar'));
    }
  }

  async function exportExempleFileUnified() {
    if (state.isLoading) return;
    try {
      const exportResponse = await apiCallDownload('/unified/export-unified-example', {});
      const link: any = document.getElementById('downloadLink');
      if (link.href !== '#') window.URL.revokeObjectURL(link.href);
      link.href = window.URL.createObjectURL(exportResponse.data);
      link.download = exportResponse.headers.filename || 'Exemplo-Unificado.xlsx';
      link.click();
      toast.success(t('sucessoExportacao'));
    } catch (err) {
      console.log(err);
      toast.error(t('naoFoiPossivelExportar'));
    }
  }

  async function onChange_textAreaUnidades(fileRef: any) {
    setState({ isSending: true, parsedRows: [] });
    try {
      const { list, tableCols, tableColsAdditionalParameters } = await apiCallFormData('/check-client-unified-batch', {
        CLIENT_ID: clientId,
      }, {
        file: fileRef,
      });
      state.parsedColsAdditionalParameters = tableColsAdditionalParameters;
      state.parsedRows = list;
      state.parsedColHeaders = tableCols;
    } catch (err) {
      console.log(err);
      const error = err as AxiosError;
      if (error.response && error.response.status !== 500) {
        toast.error(error.response.data, { closeOnClick: false, draggable: false, duration: 10000 });
      } else {
        toast.error(t('erroAnalisarDadosInseridos'));
      }
      state.parsedRows = [];
    }
    setState({ isSending: false });
  }

  async function confirmouEnviar() {
    try {
      setState({ isSending: true, resultadoEnvio: {} });
      const response = await apiCall('/add-client-unified-batch', {
        CLIENT_ID: clientId,
        datas: state.parsedRows as ApiResps['/check-client-unified-batch']['list'],
      });
      for (const row of (response.added || [])) {
        if (!row.key) continue;
        state.resultadoEnvio[row.key] = t('sucessoSalvar');
      }
      for (const row of (response.ignored || [])) {
        if ((!row.key) || (!row.reason)) continue;
        state.resultadoEnvio[row.key] = state.resultadoEnvio[row.key] ? `${state.resultadoEnvio[row.key]}\n${row.reason}` : row.reason;
      }
    } catch (err) { console.log(err); toast.error(t('houveErro')); }
    setState({ isSending: false, sended: true });
  }

  function onFilterUnitChange(units) {
    state.selectedUnit = units;
    render();
  }

  function onFilterSolutionChange(solutions) {
    state.selectedTypeOfSolution = solutions;

    render();
  }
  function selectAll() {
    typesOfSolutions.forEach((item) => item.checked = true);
    setState({ selectedTypeOfSolution: typesOfSolutions });
    render();
  }

  function clearAll() {
    typesOfSolutions.forEach((item) => item.checked = false);
    setState({ selectedTypeOfSolution: [] });
    render();
  }

  function selectAllUnit() {
    const allOptions = (state.comboOpts.units || []).map((unit) => ({ name: unit.label, value: unit.value }));
    setState({ selectedUnit: allOptions.map((item) => (item.value).toString()) });
  }

  function verifyColumn(parsedColHeaders: string[], label: string, columns: { label: string, exampleList: string[] } | undefined) {
    // TODO: find if these validations are still relevant
    // TODO: document the reason for these validations
    // TODO: 'verify' conveys that this is a validation function, but it returns a value, please rename the function or reimplement with a different scope
    if ((!parsedColHeaders) || parsedColHeaders.includes(label)) {
      // TODO: {}.label is undefined, if this is some sort of validation, throw an error instead
      return <td>{(columns || {}).label}</td>;
    }
  }

  function verifyColumnsAdditionalParameter(additionalColumns) {
    return additionalColumns.map((x, i) => <td key={i}>{x}</td>);
  }

  function verifyRowsAdditionalParameter(additionalColumns, rowAdditionalParams) {
    if (additionalColumns.length) {
      return additionalColumns.map((columnName, i) => {
        const value = rowAdditionalParams && rowAdditionalParams[columnName];
        return <td key={i}>{value || ''}</td>;
      });
    }
  }

  function verifyColumnWithoutLabel(parsedColHeaders: string[], label: string, row: any) {
    if ((!parsedColHeaders) || parsedColHeaders.includes(label)) {
      return <td>{row}</td>;
    }
  }

  const handlePaste = (event: React.ClipboardEvent<HTMLDivElement>) => {
    const pastedData = event.clipboardData.getData('Text');
    const pastedItems = pastedData.split(/\r?\n/).map((item) => item.trim());
    const matchingUnits = (state.comboOpts.units || []).filter((unit) => pastedItems.includes(unit.label)).map((unit) => String(unit.value));
    const newSelectedUnits = [...new Set([...matchingUnits])];
    setState({ selectedUnit: newSelectedUnits });
    onFilterUnitChange(newSelectedUnits);
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
  };

  if (state.isLoading || state.isSending) return <Loader />;
  if (state.isExporting) return <LoaderWithText text={t('exportandoPlanilha')} />;
  const columns = state.columns as ApiResps['/batch-input-columns']['unified'];

  const renderOption = (option) => (
    <SelectOptionStyled className={option.value} disabled={state.isLoading} style={{ width: '100%' }}>
      { (option.value === 'nobreak') && <BorderSubItem /> }
      <SelectedContent>
        <InfoSelected>
          { (option.type === 'U') && <HorizontalLineSelectParameters /> }
          <Checkbox checked={option.checked} size={18} />
          <InputStyledSelected type="checkbox" checked={option.checked} isLeft={(option.type === 'U')} />
          <span style={{ marginLeft: '10px', textDecoration: 'none', color: 'rgb(119, 129, 139)' }}>
            {
              option.value === 'utility' ? (
                <strong>
                  {option.name}
                </strong>
              )
                : option.name
            }
          </span>
        </InfoSelected>
      </SelectedContent>
    </SelectOptionStyled>
  );

  function selectedParameter(value) {
    typesOfSolutions[value.index].checked = !typesOfSolutions[value.index]?.checked;
    const Utility = ['nobreak', 'illumination', 'escada rolante', 'elevador', 'gerador', "caixa d'água", 'alarme de incêndio', 'alarme de intrusão'];
    if (addValuesParametersCircuit(value, 'utility', Utility)) {
      return;
    }
    if (filterValuesParametersCircuit(value, 'utility', 'U', Utility)) {
      return;
    }
    state.selectedTypeOfSolution = typesOfSolutions.filter((item) => item.checked);
    render();
  }

  function addValuesParametersCircuit(value, stringName, arrayValues) {
    if (value.value === stringName) {
      if (!value.checked) {
        arrayValues.forEach((option) => typesOfSolutions.forEach((item) => { if (item.value === option || item.value === value.value) { item.checked = false; } }));
      } else {
        arrayValues.forEach((option) => typesOfSolutions.forEach((item) => { if (item.value === option || item.value === value.value) { item.checked = true; } }));
      }
      state.selectedTypeOfSolution = typesOfSolutions.filter((item) => item.checked);
      render();
      return true;
    }
    return false;
  }

  function filterValuesParametersCircuit(value, circuitName, stringName, arrayValues) {
    if (value.type === stringName) {
      const filterValues = arrayValues.filter((item) => !typesOfSolutions.some((op) => op.checked && item === op.value));
      if (filterValues.length > 0) {
        typesOfSolutions.forEach((item) => { if (item.value === circuitName) { item.checked = false; } });
      } else {
        typesOfSolutions.forEach((item) => { if (item.value === circuitName) { item.checked = true; } });
      }
      state.selectedTypeOfSolution = typesOfSolutions.filter((item) => item.checked);
      render();
      return true;
    }
    return false;
  }

  return (
    <div>
      <h4 style={{ fontSize: '18px', padding: '20px 0px 0px 20px' }}>{t('unificado')}</h4>
      <ContainerExportationAndDowload style={{ padding: '20px' }}>
        <h3><b>{t('exportacaodados')}</b></h3>
        <div style={{
          marginTop: '17px',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          marginBottom: '20px',
          justifyContent: 'space-between',
          gap: '10px',
        }}
        >
          <div style={{ display: 'flex', gap: '10px', width: '100%' }}>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
              gap: '5px',
            }}
            >
              <StyleSelect>
                <div style={{ width: '100%', paddingTop: 3 }} onPaste={handlePaste}>
                  <Label>{t('unidades')}</Label>
                  <SelectSearch
                    options={(state.comboOpts.units || []).map((unit) => ({ name: unit.label, value: unit.value }))}
                    value={(state.selectedUnit || [])}
                    multiple
                    closeOnSelect={false}
                    printOptions="on-focus"
                    search
                    filterOptions={fuzzySearch}
                    placeholder={`${t('selecioneAsUnidades')}`}
                    // eslint-disable-next-line react/jsx-no-bind
                    onChange={onFilterUnitChange}
                    // onBlur={onFilterUnitBlur}
                    disabled={state.isLoading}
                  />
                </div>
              </StyleSelect>
              <Checkbox
                style={{ justifyContent: 'unset', cursor: 'auto' }}
                label={t('Selecionar todos')}
                size={20}
                checked={(state.selectedUnit?.length === state.comboOpts.units?.length)}
                onClick={() => { (state.selectedUnit?.length === state.comboOpts.units?.length) ? setState({ selectedUnit: [] }) : selectAllUnit(); render(); }}
              />
            </div>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
              gap: '5px',
            }}
            >
              <StyleSelect style={{ position: 'relative' }} hasSelected={state.selectedTypeOfSolution?.length}>
                <Label style={{ position: 'absolute', top: 8 }}>{t('tiposDeSolucao')}</Label>
                <SelectMultiple
                  options={typesOfSolutions}
                  values={(state.selectedTypeOfSolution || [])}
                  multiple
                  search
                  haveFuzzySearch
                  propLabel="name"
                  placeholder="Selecione os tipos de soluções"
                  onSelect={(value) => { selectedParameter(value); }}
                  customElements={renderOption}
                  styleBox={{ border: 'none', width: '100%' }}
                  haveCountSelect={false}
                  labelTransition={false}
                />
              </StyleSelect>
              <Checkbox
                style={{ justifyContent: 'unset', cursor: 'auto' }}
                label={t('Selecionar todos')}
                size={20}
                checked={typesOfSolutions.every((item) => item.checked)}
                onClick={() => { typesOfSolutions.every((item) => item.checked) ? clearAll() : selectAll(); render(); }}
              />
            </div>
          </div>
          <CustomizedButton
            description="Exportar"
            variant="download"
            style={{ maxWidth: '130px' }}
            onClick={(_item) => exportUnitUnified()}
          />
        </div>
        {
          (state.parsedRows.length === 0) && (
            <>
              <h3><b>Upload de Dados</b></h3>
              <section style={{ marginBottom: '20px' }}>
                <CustomizedButton
                  style={{
                    backgroundColor: '#363BC4',
                    color: 'white',
                    display: 'flex',
                    alignItems: 'center',
                    width: '150px',
                    cursor: 'pointer',
                  }}
                  colorIcon="#FFFFFF"
                  description="DOWNLOAD"
                  variant="download"
                  onClick={() => exportExempleFileUnified()}
                />
                <p>
                  <b>{t('orientacoes')}</b>
                  <br />
                  {t('baixeEUtilizeComoModelo')}
                  <br />
                  {t('preenchaTabelaXlsx')}
                  <br />
                  {t('obsData')}
                  <br />
                  {t('obsParametroAdicional')}
                  <br />
                </p>
                <FileInput
                  onChange={(e: any) => { onChange_textAreaUnidades(e.target.files[0]); }}
                  style={{
                    backgroundColor: '#363BC4',
                    borderColor: colors.Blue300,
                    borderRadius: '5px',
                    boxShadow: 'unset',
                  }}
                >
                  <span style={{
                    display: 'inline-block',
                    width: '200px',
                    textAlign: 'center',
                    marginTop: '15px',
                  }}
                  >
                    {t('selecionarArquivo')}
                  </span>
                  <input type="file" hidden />
                </FileInput>
              </section>
            </>
          )
        }
        {(state.parsedRows.length > 0) && (
          <>
            <h3><b>{t('previsualizacaoEnvio')}</b></h3>
            <div style={{ overflow: 'auto' }}>
              <Table>
                <thead>
                  <tr>
                    <th>{t('status')}</th>
                    {verifyColumn(state.parsedColHeaders, 'SOLUTION_TYPE', columns?.SOLUTION_TYPE)}
                    {verifyColumn(state.parsedColHeaders, 'UNIT_NAME', columns?.UNIT_NAME)}
                    {verifyColumn(state.parsedColHeaders, 'UNIT_ID', columns?.UNIT_ID)}
                    {verifyColumn(state.parsedColHeaders, 'UNIT_CODE_CELSIUS', columns?.UNIT_CODE_CELSIUS)}
                    {verifyColumn(state.parsedColHeaders, 'UNIT_CODE_API', columns?.UNIT_CODE_API)}
                    {verifyColumn(state.parsedColHeaders, 'COUNTRY', columns?.COUNTRY)}
                    {verifyColumn(state.parsedColHeaders, 'STATE_ID', columns?.STATE_ID)}
                    {verifyColumn(state.parsedColHeaders, 'CITY_NAME', columns?.CITY_NAME)}
                    {verifyColumn(state.parsedColHeaders, 'OPEN_HOUR', columns?.OPEN_HOUR)}
                    {verifyColumn(state.parsedColHeaders, 'CLOSE_HOUR', columns?.CLOSE_HOUR)}
                    {verifyColumn(state.parsedColHeaders, 'EXCEPTION_OPERATING_HOURS', columns?.EXCEPTION_OPERATING_HOURS)}
                    {verifyColumn(state.parsedColHeaders, 'TIME_ZONE', columns?.TIME_ZONE)}
                    {verifyColumn(state.parsedColHeaders, 'CONSTRUCTED_AREA', columns?.CONSTRUCTED_AREA)}
                    {verifyColumn(state.parsedColHeaders, 'UNIT_STATUS', columns?.UNIT_STATUS)}
                    {verifyColumn(state.parsedColHeaders, 'LATLONG', columns?.LATLONG)}
                    {verifyColumn(state.parsedColHeaders, 'ADDRESS', columns?.ADDRESS)}
                    {verifyColumn(state.parsedColHeaders, 'AMOUNT_PEOPLE', columns?.AMOUNT_PEOPLE)}
                    {verifyColumn(state.parsedColHeaders, 'ICCID', columns?.ICCID)}
                    {verifyColumn(state.parsedColHeaders, 'ACCESSPOINT', columns?.ACCESSPOINT)}
                    {verifyColumn(state.parsedColHeaders, 'MODEM', columns?.MODEM)}
                    {verifyColumn(state.parsedColHeaders, 'MACACCESSPOINT', columns?.MACACCESSPOINT)}
                    {verifyColumn(state.parsedColHeaders, 'MACREPEATER', columns?.MACREPEATER)}
                    {verifyColumn(state.parsedColHeaders, 'SIMCARD_PHOTO1', columns?.SIMCARD_PHOTO1)}
                    {verifyColumn(state.parsedColHeaders, 'SIMCARD_PHOTO2', columns?.SIMCARD_PHOTO2)}
                    {verifyColumn(state.parsedColHeaders, 'SIMCARD_PHOTO3', columns?.SIMCARD_PHOTO3)}
                    {verifyColumn(state.parsedColHeaders, 'SKETCH_1', columns?.SKETCH_1)}
                    {verifyColumn(state.parsedColHeaders, 'SKETCH_2', columns?.SKETCH_2)}
                    {verifyColumn(state.parsedColHeaders, 'SKETCH_3', columns?.SKETCH_3)}
                    {verifyColumn(state.parsedColHeaders, 'SKETCH_4', columns?.SKETCH_4)}
                    {verifyColumn(state.parsedColHeaders, 'SKETCH_5', columns?.SKETCH_5)}
                    {verifyColumn(state.parsedColHeaders, 'GROUP_ID', columns?.GROUP_ID)}
                    {verifyColumn(state.parsedColHeaders, 'GROUP_NAME', columns?.GROUP_NAME)}
                    {verifyColumn(state.parsedColHeaders, 'MACHINE_TAG', columns?.MACHINE_TAG)}
                    {verifyColumn(state.parsedColHeaders, 'INSTALLATION_DATE', columns?.INSTALLATION_DATE)}
                    {verifyColumn(state.parsedColHeaders, 'MCHN_APPL', columns?.MCHN_APPL)}
                    {verifyColumn(state.parsedColHeaders, 'GROUP_TYPE', columns?.GROUP_TYPE)}
                    {verifyColumn(state.parsedColHeaders, 'MCHN_BRAND', columns?.MCHN_BRAND)}
                    {verifyColumn(state.parsedColHeaders, 'FLUID_TYPE', columns?.FLUID_TYPE)}
                    {verifyColumn(state.parsedColHeaders, 'MACHINE_RATED_POWER', columns?.MACHINE_RATED_POWER)}
                    {verifyColumn(state.parsedColHeaders, 'MACHINE_COOLING_CAPACITY', columns?.MACHINE_COOLING_CAPACITY)}
                    {verifyColumn(state.parsedColHeaders, 'PHOTO_DEVGROUPS_1', columns?.PHOTO_DEVGROUPS_1)}
                    {verifyColumn(state.parsedColHeaders, 'PHOTO_DEVGROUPS_2', columns?.PHOTO_DEVGROUPS_2)}
                    {verifyColumn(state.parsedColHeaders, 'PHOTO_DEVGROUPS_3', columns?.PHOTO_DEVGROUPS_3)}
                    {verifyColumn(state.parsedColHeaders, 'PHOTO_DEVGROUPS_4', columns?.PHOTO_DEVGROUPS_4)}
                    {verifyColumn(state.parsedColHeaders, 'PHOTO_DEVGROUPS_5', columns?.PHOTO_DEVGROUPS_5)}
                    {verifyColumn(state.parsedColHeaders, 'DEV_AUTOM_ID', columns?.DEV_AUTOM_ID)}
                    {verifyColumn(state.parsedColHeaders, 'PLACEMENT', columns?.PLACEMENT)}
                    {verifyColumn(state.parsedColHeaders, 'SENSORS_DUT_DUO', columns?.SENSORS_DUT_DUO)}
                    {verifyColumn(state.parsedColHeaders, 'DAM_INSTALLATION_LOCATION', columns?.DAM_INSTALLATION_LOCATION)}
                    {verifyColumn(state.parsedColHeaders, 'DAM_PLACEMENT', columns?.DAM_PLACEMENT)}
                    {verifyColumn(state.parsedColHeaders, 'DAM_T0_POSITION', columns?.DAM_T0_POSITION)}
                    {verifyColumn(state.parsedColHeaders, 'DAM_T1_POSITION', columns?.DAM_T1_POSITION)}
                    {verifyColumn(state.parsedColHeaders, 'PHOTO_AUTOM_DEV_1', columns?.PHOTO_AUTOM_DEV_1)}
                    {verifyColumn(state.parsedColHeaders, 'PHOTO_AUTOM_DEV_2', columns?.PHOTO_AUTOM_DEV_2)}
                    {verifyColumn(state.parsedColHeaders, 'PHOTO_AUTOM_DEV_3', columns?.PHOTO_AUTOM_DEV_3)}
                    {verifyColumn(state.parsedColHeaders, 'PHOTO_AUTOM_DEV_4', columns?.PHOTO_AUTOM_DEV_4)}
                    {verifyColumn(state.parsedColHeaders, 'PHOTO_AUTOM_DEV_5', columns?.PHOTO_AUTOM_DEV_5)}
                    {verifyColumn(state.parsedColHeaders, 'DEV_REFERENCE_ID', columns?.DEV_REFERENCE_ID)}
                    {verifyColumn(state.parsedColHeaders, 'PHOTO_DEV_REFERENCE_1', columns?.PHOTO_DEV_REFERENCE_1)}
                    {verifyColumn(state.parsedColHeaders, 'PHOTO_DEV_REFERENCE_2', columns?.PHOTO_DEV_REFERENCE_2)}
                    {verifyColumn(state.parsedColHeaders, 'PHOTO_DEV_REFERENCE_3', columns?.PHOTO_DEV_REFERENCE_3)}
                    {verifyColumn(state.parsedColHeaders, 'PHOTO_DEV_REFERENCE_4', columns?.PHOTO_DEV_REFERENCE_4)}
                    {verifyColumn(state.parsedColHeaders, 'PHOTO_DEV_REFERENCE_5', columns?.PHOTO_DEV_REFERENCE_5)}
                    {verifyColumn(state.parsedColHeaders, 'ROOM_NAME', columns?.ROOM_NAME)}
                    {verifyColumn(state.parsedColHeaders, 'RTYPE_NAME', columns?.RTYPE_NAME)}
                    {verifyColumn(state.parsedColHeaders, 'ENVIRONMENT_CATEGORY', columns?.ENVIRONMENT_CATEGORY)}
                    {verifyColumn(state.parsedColHeaders, 'DAT_ID', columns?.DAT_ID)}
                    {verifyColumn(state.parsedColHeaders, 'AST_DESC', columns?.AST_DESC)}
                    {verifyColumn(state.parsedColHeaders, 'ASSET_TAG', columns?.MACHINE_TAG)}
                    {verifyColumn(state.parsedColHeaders, 'AST_ROLE_NAME', columns?.AST_ROLE_NAME)}
                    {verifyColumn(state.parsedColHeaders, 'ASSET_MODEL', columns?.ASSET_MODEL)}
                    {verifyColumn(state.parsedColHeaders, 'CAPACITY_POWER', columns?.CAPACITY_POWER)}
                    {verifyColumn(state.parsedColHeaders, 'DAC_COP', columns?.DAC_COP)}
                    {verifyColumn(state.parsedColHeaders, 'ASSET_RATED_POWER', columns?.ASSET_RATED_POWER)}
                    {verifyColumn(state.parsedColHeaders, 'EVAPORATOR_MODEL', columns?.EVAPORATOR_MODEL)}
                    {verifyColumn(state.parsedColHeaders, 'INSUFFLATION_SPEED', columns?.INSUFFLATION_SPEED)}
                    {verifyColumn(state.parsedColHeaders, 'COMPRESSOR_RLA', columns?.COMPRESSOR_RLA)}
                    {verifyColumn(state.parsedColHeaders, 'EQUIPMENT_POWER', columns?.EQUIPMENT_POWER)}
                    {verifyColumn(state.parsedColHeaders, 'PHOTO_ASSET_1', columns?.PHOTO_ASSET_1)}
                    {verifyColumn(state.parsedColHeaders, 'PHOTO_ASSET_2', columns?.PHOTO_ASSET_2)}
                    {verifyColumn(state.parsedColHeaders, 'PHOTO_ASSET_3', columns?.PHOTO_ASSET_3)}
                    {verifyColumn(state.parsedColHeaders, 'PHOTO_ASSET_4', columns?.PHOTO_ASSET_4)}
                    {verifyColumn(state.parsedColHeaders, 'PHOTO_ASSET_5', columns?.PHOTO_ASSET_5)}
                    {verifyColumn(state.parsedColHeaders, 'DEV_ID', columns?.DEV_ID)}
                    {verifyColumn(state.parsedColHeaders, 'DAC_COMIS', columns?.DAC_COMIS)}
                    {verifyColumn(state.parsedColHeaders, 'P0_SENSOR', columns?.P0_SENSOR)}
                    {verifyColumn(state.parsedColHeaders, 'P0_POSITN', columns?.P0_POSITN)}
                    {verifyColumn(state.parsedColHeaders, 'P1_SENSOR', columns?.P1_SENSOR)}
                    {verifyColumn(state.parsedColHeaders, 'P1_POSITN', columns?.P1_POSITN)}
                    {verifyColumn(state.parsedColHeaders, 'PHOTO_DAC_1', columns?.PHOTO_DAC_1)}
                    {verifyColumn(state.parsedColHeaders, 'PHOTO_DAC_2', columns?.PHOTO_DAC_2)}
                    {verifyColumn(state.parsedColHeaders, 'PHOTO_DAC_3', columns?.PHOTO_DAC_3)}
                    {verifyColumn(state.parsedColHeaders, 'PHOTO_DAC_4', columns?.PHOTO_DAC_4)}
                    {verifyColumn(state.parsedColHeaders, 'PHOTO_DAC_5', columns?.PHOTO_DAC_5)}
                    {verifyColumn(state.parsedColHeaders, 'ELECTRIC_CIRCUIT_ID', columns?.ELECTRIC_CIRCUIT_ID)}
                    {verifyColumn(state.parsedColHeaders, 'ELECTRIC_CIRCUIT_NAME', columns?.ELECTRIC_CIRCUIT_NAME)}
                    {verifyColumn(state.parsedColHeaders, 'ELECTRIC_CIRCUIT_TYPE', columns?.ELECTRIC_CIRCUIT_TYPE)}
                    {verifyColumn(state.parsedColHeaders, 'ENERGY_DEVICES_INFO_ID', columns?.ENERGY_DEVICES_INFO_ID)}
                    {verifyColumn(state.parsedColHeaders, 'ID_MED_ENERGY', columns?.ID_MED_ENERGY)}
                    {verifyColumn(state.parsedColHeaders, 'NUM_SERIE_MED_ENERGY', columns?.NUM_SERIE_MED_ENERGY)}
                    {verifyColumn(state.parsedColHeaders, 'MODEL_MED_ENERGY', columns?.MODEL_MED_ENERGY)}
                    {verifyColumn(state.parsedColHeaders, 'CAPACITY_TCA', columns?.CAPACITY_TCA)}
                    {verifyColumn(state.parsedColHeaders, 'INSTALLATION_ELETRICAL_TYPE', columns?.INSTALLATION_ELETRICAL_TYPE)}
                    {verifyColumn(state.parsedColHeaders, 'SHIPPING_INTERVAL', columns?.SHIPPING_INTERVAL)}
                    {verifyColumn(state.parsedColHeaders, 'ROOM_VAV', columns?.ROOM_VAV)}
                    {verifyColumn(state.parsedColHeaders, 'THERM_MANUF', columns?.THERM_MANUF)}
                    {verifyColumn(state.parsedColHeaders, 'THERM_MODEL', columns?.THERM_MODEL)}
                    {verifyColumn(state.parsedColHeaders, 'VALVE_MANUF', columns?.VALVE_MANUF)}
                    {verifyColumn(state.parsedColHeaders, 'VALVE_MODEL', columns?.VALVE_MODEL)}
                    {verifyColumn(state.parsedColHeaders, 'VALVE_TYPE', columns?.VALVE_TYPE)}
                    {verifyColumn(state.parsedColHeaders, 'BOX_MANUF', columns?.BOX_MANUF)}
                    {verifyColumn(state.parsedColHeaders, 'BOX_MODEL', columns?.BOX_MODEL)}
                    {verifyColumn(state.parsedColHeaders, 'FANCOIL_MANUF', columns?.FANCOIL_MANUF)}
                    {verifyColumn(state.parsedColHeaders, 'FANCOIL_MODEL', columns?.FANCOIL_MODEL)}
                    {verifyColumn(state.parsedColHeaders, 'PHOTO_DRI_1', columns?.PHOTO_DRI_1)}
                    {verifyColumn(state.parsedColHeaders, 'PHOTO_DRI_2', columns?.PHOTO_DRI_2)}
                    {verifyColumn(state.parsedColHeaders, 'PHOTO_DRI_3', columns?.PHOTO_DRI_3)}
                    {verifyColumn(state.parsedColHeaders, 'PHOTO_DRI_4', columns?.PHOTO_DRI_4)}
                    {verifyColumn(state.parsedColHeaders, 'PHOTO_DRI_5', columns?.PHOTO_DRI_5)}
                    {verifyColumn(state.parsedColHeaders, 'DMA_ID', columns?.DMA_ID)}
                    {verifyColumn(state.parsedColHeaders, 'HYDROMETER_MODEL', columns?.HYDROMETER_MODEL)}
                    {verifyColumn(state.parsedColHeaders, 'INSTALLATION_LOCATION', columns?.INSTALLATION_LOCATION)}
                    {verifyColumn(state.parsedColHeaders, 'WATER_INSTALLATION_DATE', columns?.WATER_INSTALLATION_DATE)}
                    {verifyColumn(state.parsedColHeaders, 'TOTAL_CAPACITY', columns?.TOTAL_CAPACITY)}
                    {verifyColumn(state.parsedColHeaders, 'TOTAL_RESERVOIRS', columns?.TOTAL_RESERVOIRS)}
                    {verifyColumn(state.parsedColHeaders, 'PHOTO_DMA_1', columns?.PHOTO_DMA_1)}
                    {verifyColumn(state.parsedColHeaders, 'PHOTO_DMA_2', columns?.PHOTO_DMA_2)}
                    {verifyColumn(state.parsedColHeaders, 'PHOTO_DMA_3', columns?.PHOTO_DMA_3)}
                    {verifyColumn(state.parsedColHeaders, 'PHOTO_DMA_4', columns?.PHOTO_DMA_4)}
                    {verifyColumn(state.parsedColHeaders, 'PHOTO_DMA_5', columns?.PHOTO_DMA_5)}
                    {verifyColumn(state.parsedColHeaders, 'UTILITY_ID', columns?.UTILITY_ID)}
                    {verifyColumn(state.parsedColHeaders, 'UTILITY_APPLICATION', columns?.UTILITY_APPLICATION)}
                    {verifyColumn(state.parsedColHeaders, 'UTILITY_NAME', columns?.UTILITY_NAME)}
                    {verifyColumn(state.parsedColHeaders, 'INSTALLATION_DATE_UTIL', columns?.INSTALLATION_DATE_UTIL)}
                    {verifyColumn(state.parsedColHeaders, 'DISTRIBUTOR', columns?.DISTRIBUTOR)}
                    {verifyColumn(state.parsedColHeaders, 'MODEL', columns?.MODEL)}
                    {verifyColumn(state.parsedColHeaders, 'GRID_VOLTAGE', columns?.GRID_VOLTAGE)}
                    {verifyColumn(state.parsedColHeaders, 'MAINS_CURRENT', columns?.MAINS_CURRENT)}
                    {verifyColumn(state.parsedColHeaders, 'ASSOCIATE_DEV', columns?.ASSOCIATE_DEV)}
                    {verifyColumn(state.parsedColHeaders, 'ASSOCIATE_DEV_FEEDBACK', columns?.ASSOCIATE_DEV_FEEDBACK)}
                    {verifyColumn(state.parsedColHeaders, 'PORT_UTILITY', columns?.PORT_UTILITY)}
                    {verifyColumn(state.parsedColHeaders, 'CURRENT_TRANSFORMER', columns?.CURRENT_TRANSFORMER)}
                    {verifyColumn(state.parsedColHeaders, 'CURRENT_SENSOR', columns?.CURRENT_SENSOR)}
                    {verifyColumn(state.parsedColHeaders, 'ASSOCIATE_ASSET', columns?.ASSOCIATE_ASSET)}
                    {verifyColumn(state.parsedColHeaders, 'PHOTO_DMT', columns?.PHOTO_DMT)}
                    {verifyColumn(state.parsedColHeaders, 'PHOTO_DAL', columns?.PHOTO_DAL)}
                    {verifyColumn(state.parsedColHeaders, 'PHOTO_UTILITY', columns?.PHOTO_UTILITY)}
                    {verifyColumnsAdditionalParameter(state.parsedColsAdditionalParameters)}
                  </tr>
                </thead>
                <tbody>
                  {state.parsedRows.map((row) => (
                    <tr key={row.key}>
                      <td>
                        <pre style={{ margin: '0' }}>{row.errors.map((e) => e.message).join('\n') || 'OK'}</pre>
                        {state.resultadoEnvio[row.key] && <div><pre>{state.resultadoEnvio[row.key]}</pre></div>}
                      </td>
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'SOLUTION_TYPE', row.SOLUTION_TYPE)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'UNIT_NAME', row.UNIT_NAME)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'UNIT_ID', row.UNIT_ID)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'UNIT_CODE_CELSIUS', row.UNIT_CODE_CELSIUS)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'UNIT_CODE_API', row.UNIT_CODE_API)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'COUNTRY', row.COUNTRY)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'STATE_ID', row.STATE_ID)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'CITY_NAME', row.CITY_NAME)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'OPEN_HOUR', row.OPEN_HOUR)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'CLOSE_HOUR', row.CLOSE_HOUR)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'EXCEPTION_OPERATING_HOURS', row.EXCEPTION_OPERATING_HOURS)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'TIME_ZONE', row.TIME_ZONE)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'CONSTRUCTED_AREA', row.CONSTRUCTED_AREA && formatNumber(row.CONSTRUCTED_AREA))}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'UNIT_STATUS', row.UNIT_STATUS)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'LATLONG', row.LATLONG)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'ADDRESS', row.ADDRESS)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'AMOUNT_PEOPLE', row.AMOUNT_PEOPLE)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'ICCID', row.ICCID)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'ACCESSPOINT', row.ACCESSPOINT)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'MODEM', row.MODEM)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'MACACCESSPOINT', row.MACACCESSPOINT)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'MACREPEATER', row.MACREPEATER)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'SIMCARD_PHOTO1', row.SIMCARD_PHOTO1)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'SIMCARD_PHOTO2', row.SIMCARD_PHOTO2)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'SIMCARD_PHOTO3', row.SIMCARD_PHOTO3)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'SKETCH_1', row.SKETCH_1)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'SKETCH_2', row.SKETCH_2)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'SKETCH_3', row.SKETCH_3)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'SKETCH_4', row.SKETCH_4)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'SKETCH_5', row.SKETCH_5)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'GROUP_ID', row.GROUP_ID)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'GROUP_NAME', row.GROUP_NAME)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'MACHINE_TAG', row.MACHINE_TAG)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'INSTALLATION_DATE', row.INSTALLATION_DATE)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'MCHN_APPL', row.MCHN_APPL)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'GROUP_TYPE', row.GROUP_TYPE)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'MCHN_BRAND', row.MCHN_BRAND)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'FLUID_TYPE', row.FLUID_TYPE)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'MACHINE_RATED_POWER', row.MACHINE_RATED_POWER)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'MACHINE_COOLING_CAPACITY', row.MACHINE_COOLING_CAPACITY)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'PHOTO_DEVGROUPS_1', row.PHOTO_DEVGROUPS_1)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'PHOTO_DEVGROUPS_2', row.PHOTO_DEVGROUPS_2)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'PHOTO_DEVGROUPS_3', row.PHOTO_DEVGROUPS_3)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'PHOTO_DEVGROUPS_4', row.PHOTO_DEVGROUPS_4)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'PHOTO_DEVGROUPS_5', row.PHOTO_DEVGROUPS_5)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'DEV_AUTOM_ID', row.DEV_AUTOM_ID)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'PLACEMENT', row.PLACEMENT)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'SENSORS_DUT_DUO', row.SENSORS_DUT_DUO)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'DAM_INSTALLATION_LOCATION', row.DAM_INSTALLATION_LOCATION)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'DAM_PLACEMENT', row.DAM_PLACEMENT)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'DAM_T0_POSITION', row.DAM_T0_POSITION)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'DAM_T1_POSITION', row.DAM_T1_POSITION)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'PHOTO_AUTOM_DEV_1', row.PHOTO_AUTOM_DEV_1)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'PHOTO_AUTOM_DEV_2', row.PHOTO_AUTOM_DEV_2)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'PHOTO_AUTOM_DEV_3', row.PHOTO_AUTOM_DEV_3)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'PHOTO_AUTOM_DEV_4', row.PHOTO_AUTOM_DEV_4)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'PHOTO_AUTOM_DEV_5', row.PHOTO_AUTOM_DEV_5)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'DEV_REFERENCE_ID', row.DEV_REFERENCE_ID)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'PHOTO_DEV_REFERENCE_1', row.PHOTO_DEV_REFERENCE_1)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'PHOTO_DEV_REFERENCE_2', row.PHOTO_DEV_REFERENCE_2)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'PHOTO_DEV_REFERENCE_3', row.PHOTO_DEV_REFERENCE_3)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'PHOTO_DEV_REFERENCE_4', row.PHOTO_DEV_REFERENCE_4)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'PHOTO_DEV_REFERENCE_5', row.PHOTO_DEV_REFERENCE_5)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'ROOM_NAME', row.ROOM_NAME)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'RTYPE_NAME', row.RTYPE_NAME)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'ENVIRONMENT_CATEGORY', row.ENVIRONMENT_CATEGORY)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'DAT_ID', row.DAT_ID)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'AST_DESC', row.AST_DESC)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'ASSET_TAG', row.ASSET_TAG)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'AST_ROLE_NAME', row.AST_ROLE_NAME)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'ASSET_MODEL', row.ASSET_MODEL)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'CAPACITY_POWER', row.CAPACITY_POWER)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'DAC_COP', row.DAC_COP)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'ASSET_RATED_POWER', row.ASSET_RATED_POWER)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'EVAPORATOR_MODEL', row.EVAPORATOR_MODEL)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'INSUFFLATION_SPEED', row.INSUFFLATION_SPEED)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'COMPRESSOR_RLA', row.COMPRESSOR_RLA)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'EQUIPMENT_POWER', row.EQUIPMENT_POWER)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'PHOTO_ASSET_1', row.PHOTO_ASSET_1)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'PHOTO_ASSET_2', row.PHOTO_ASSET_2)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'PHOTO_ASSET_3', row.PHOTO_ASSET_3)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'PHOTO_ASSET_4', row.PHOTO_ASSET_4)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'PHOTO_ASSET_5', row.PHOTO_ASSET_5)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'DEV_ID', row.DEV_ID)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'DAC_COMIS', row.DAC_COMIS)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'P0_SENSOR', row.P0_SENSOR)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'P0_POSITN', row.P0_POSITN)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'P1_SENSOR', row.P1_SENSOR)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'P1_POSITN', row.P1_POSITN)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'PHOTO_DAC_1', row.PHOTO_DAC_1)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'PHOTO_DAC_2', row.PHOTO_DAC_2)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'PHOTO_DAC_3', row.PHOTO_DAC_3)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'PHOTO_DAC_4', row.PHOTO_DAC_4)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'PHOTO_DAC_5', row.PHOTO_DAC_5)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'ELECTRIC_CIRCUIT_ID', row.ELECTRIC_CIRCUIT_ID)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'ELECTRIC_CIRCUIT_NAME', row.ELECTRIC_CIRCUIT_NAME)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'ELECTRIC_CIRCUIT_TYPE', row.ELECTRIC_CIRCUIT_TYPE)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'ENERGY_DEVICES_INFO_ID', row.ENERGY_DEVICES_INFO_ID)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'ID_MED_ENERGY', row.ID_MED_ENERGY)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'NUM_SERIE_MED_ENERGY', row.NUM_SERIE_MED_ENERGY)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'MODEL_MED_ENERGY', row.MODEL_MED_ENERGY)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'CAPACITY_TCA', row.CAPACITY_TCA)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'INSTALLATION_ELETRICAL_TYPE', row.INSTALLATION_ELETRICAL_TYPE)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'SHIPPING_INTERVAL', row.SHIPPING_INTERVAL)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'ROOM_VAV', row.ROOM_VAV)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'THERM_MANUF', row.THERM_MANUF)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'THERM_MODEL', row.THERM_MODEL)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'VALVE_MANUF', row.VALVE_MANUF)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'VALVE_MODEL', row.VALVE_MODEL)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'VALVE_TYPE', row.VALVE_TYPE)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'BOX_MANUF', row.BOX_MANUF)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'BOX_MODEL', row.BOX_MODEL)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'FANCOIL_MANUF', row.FANCOIL_MANUF)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'FANCOIL_MODEL', row.FANCOIL_MODEL)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'PHOTO_DRI_1', row.PHOTO_DRI_1)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'PHOTO_DRI_2', row.PHOTO_DRI_2)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'PHOTO_DRI_3', row.PHOTO_DRI_3)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'PHOTO_DRI_4', row.PHOTO_DRI_4)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'PHOTO_DRI_5', row.PHOTO_DRI_5)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'DMA_ID', row.DMA_ID)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'HYDROMETER_MODEL', row.HYDROMETER_MODEL)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'INSTALLATION_LOCATION', row.INSTALLATION_LOCATION)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'WATER_INSTALLATION_DATE', row.WATER_INSTALLATION_DATE)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'TOTAL_CAPACITY', row.TOTAL_CAPACITY)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'TOTAL_RESERVOIRS', row.TOTAL_RESERVOIRS)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'PHOTO_DMA_1', row.PHOTO_DMA_1)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'PHOTO_DMA_2', row.PHOTO_DMA_2)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'PHOTO_DMA_3', row.PHOTO_DMA_3)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'PHOTO_DMA_4', row.PHOTO_DMA_4)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'PHOTO_DMA_5', row.PHOTO_DMA_5)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'UTILITY_ID', row.UTILITY_ID)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'UTILITY_APPLICATION', row.UTILITY_APPLICATION)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'UTILITY_NAME', row.UTILITY_NAME)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'INSTALLATION_DATE_UTIL', row.INSTALLATION_DATE_UTIL)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'DISTRIBUTOR', row.DISTRIBUTOR)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'MODEL', row.MODEL)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'GRID_VOLTAGE', row.GRID_VOLTAGE)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'MAINS_CURRENT', row.MAINS_CURRENT)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'ASSOCIATE_DEV', row.ASSOCIATE_DEV)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'ASSOCIATE_DEV_FEEDBACK', row.ASSOCIATE_DEV_FEEDBACK)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'PORT_UTILITY', row.PORT_UTILITY)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'CURRENT_TRANSFORMER', row.CURRENT_TRANSFORMER)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'CURRENT_SENSOR', row.CURRENT_SENSOR)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'ASSOCIATE_ASSET', row.ASSOCIATE_ASSET)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'PHOTO_DMT', row.PHOTO_DMT)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'PHOTO_DAL', row.PHOTO_DAL)}
                      {verifyColumnWithoutLabel(state.parsedColHeaders, 'PHOTO_UTILITY', row.PHOTO_UTILITY)}
                      {verifyRowsAdditionalParameter(state.parsedColsAdditionalParameters, row.ADDITIONAL_PARAMETERS)}
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
            <div style={{ display: 'flex', paddingTop: '30px' }}>
              {!state.sended
                && (
                <Button style={{ width: '140px' }} onClick={confirmouEnviar} variant="primary">
                  {t('botaoEnviar')}
                </Button>
                )}
              {!state.sended
                && (
                  <Button style={{ width: '140px', margin: '0 20px' }} onClick={() => setState({ parsedRows: [], sended: false })} variant="grey">
                    {t('cancelar')}
                  </Button>
                )}
              {state.sended && (
                <Link to={`/painel/clientes/editar-cliente/${clientId}`}>
                  <Button style={{ width: '140px', color: 'black' }} variant="grey">
                    {t('voltar')}
                  </Button>
                </Link>
              )}

            </div>
          </>
        )}
      </ContainerExportationAndDowload>
      <h3 style={{ paddingLeft: '20px', paddingBottom: '35px' }}><b>{t('guiadePreenchimento')}</b></h3>
      <PreFillGuideArea>
        <div style={{
          display: 'flex',
          gap: '5px',
          position: 'inherit',
          top: '-35px',
        }}
        >
          <BottonTypeSolution
            onClick={() => setState({ selectedTypeSolution: 'unit' })}
            isClicked={state.selectedTypeSolution === 'unit'}
            style={{ borderLeft: '0px', cursor: 'pointer' }}
          >
            Unidade
          </BottonTypeSolution>
          <BottonTypeSolution
            onClick={() => setState({ selectedTypeSolution: 'machine' })}
            isClicked={state.selectedTypeSolution === 'machine'}
            style={{ cursor: 'pointer' }}
          >
            Máquina
          </BottonTypeSolution>
          <BottonTypeSolution
            onClick={() => setState({ selectedTypeSolution: 'environment' })}
            isClicked={state.selectedTypeSolution === 'environment'}
            style={{ cursor: 'pointer' }}
          >
            Ambientes
          </BottonTypeSolution>
          <BottonTypeSolution
            onClick={() => setState({ selectedTypeSolution: 'energy' })}
            isClicked={state.selectedTypeSolution === 'energy'}
            style={{ cursor: 'pointer' }}
          >
            Energia
          </BottonTypeSolution>
          <BottonTypeSolution
            onClick={() => setState({ selectedTypeSolution: 'water' })}
            isClicked={state.selectedTypeSolution === 'water'}
            style={{ cursor: 'pointer' }}
          >
            Água
          </BottonTypeSolution>
          <BottonTypeSolution
            onClick={() => setState({ selectedTypeSolution: 'utility' })}
            isClicked={state.selectedTypeSolution === 'utility'}
            style={{ cursor: 'pointer' }}
          >
            {t('utilitario')}
          </BottonTypeSolution>
        </div>
        <div style={{ padding: '0px 30px 30px', backgroundColor: '#FFFFFF' }}>
          <PreFillGuide
            typeOfSolution={state.selectedTypeSolution}
            comboOpts={state.comboOpts}
            energyOpts={state.energyOpts}
          />
        </div>
      </PreFillGuideArea>
    </div>
  );
};
